import { render, staticRenderFns } from "./Noticeread.vue?vue&type=template&id=030082f2&scoped=true&"
import script from "./Noticeread.vue?vue&type=script&lang=js&"
export * from "./Noticeread.vue?vue&type=script&lang=js&"
import style0 from "./Noticeread.vue?vue&type=style&index=0&id=030082f2&scoped=true&lang=css&"
import style1 from "./Noticeread.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030082f2",
  null
  
)

export default component.exports